export default __webpack_public_path__ + "static/media/fastShoesModel.530c5f8c.glb";